var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashedArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 7,
    viewBox: "0 0 36 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.6666 3.5L30.6666 0.613249V6.38675L35.6666 3.5ZM0.666626 4H1.63885V3H0.666626V4ZM3.58329 4H5.52774V3H3.58329V4ZM7.47218 4H9.41663V3H7.47218V4ZM11.3611 4H13.3055V3H11.3611V4ZM15.25 4H17.1944V3H15.25V4ZM19.1388 4H21.0833V3H19.1388V4ZM23.0277 4H24.9722V3H23.0277V4ZM26.9166 4H28.8611V3H26.9166V4ZM30.8055 4H32.75V3H30.8055V4Z",
    fill: "#2750FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashedArrow);
export default __webpack_public_path__ + "static/media/dashed_arrow.862cdbc3293700846fc1165f48a8f49d.svg";
export { ForwardRef as ReactComponent };